import type { AlternativesOverlaySource } from '~/composables/useAlternativesEntry'

/**
 * Backs the single `ProductAlternativesBottomSheet` (scope `'all'`) mounted in
 * `layouts/default.vue`, shared across PLP/category tiles and the PDP for
 * hybrid-search customers.
 */
export function useAlternativesOverlay() {
  const isOpen = useState('alternatives-overlay:isOpen', () => false)
  const source = useState<AlternativesOverlaySource | null>('alternatives-overlay:source', () => null)
  const { track: trackProductFruits } = useProductFruits()

  function open(next: AlternativesOverlaySource) {
    source.value = next
    isOpen.value = true
    trackProductFruits('exploreProductAlternatives')
  }

  function close() {
    isOpen.value = false
  }

  return {
    isOpen,
    source,
    open,
    close,
  }
}
